/*
  # Radio selection text

  This can be combined with an accordion to make a custom
  dropdownlist (use the custom-dropdown-list pattern) or
  expanded with more attributes to offer more information
  about a radio selection (for this use case, the recommendation
  is to rename data-radio-selection-text into different
  properties such as data-radio-selection-heading
  and data-radio-selection-summary.)

  To use this controller for multiple purposes, consider
  wrapping individual attribute applications in `if` statements:

      if ( textSource.dataset.radioSelectionText ) {
        textTarget.textContent = textSource.dataset.radioSelectionText
      }
      if ( textSource.dataset.radioSelectionHeading ) {
        textTarget.textContent = textSource.dataset.radioSelectionHeading
      }

  Descendant elements:

  - radioSelectionText.textTarget - the element whose textContent
    should represent the selected radio button.
  - radioSelectionText.textSource - the radio buttons, whose
    text for the textTarget is set using the
    data-radio-selection-text attribute.

*/

import { assignController, selectAll, getControllers } from '../api/element-manipulation'

assignController('radioSelectionText', (element) => {
  const onSelected = []
  const textTarget = element.querySelector('[data-hook~="radioSelectionText.textTarget"]')
  const textSources = selectAll(element, '[data-hook~="radioSelectionText.textSource"]')
  const selected = event => {
    const textSource = event.currentTarget
    textTarget.textContent = textSource.dataset.radioSelectionText
    onSelected.forEach ( listener => listener(
      {
        sender: controller,
        textSource,
      }
    ) )
  }
  textSources.forEach ( textSource => {
    textSource.addEventListener('change', selected)
    textSource.addEventListener('click', selected)
  } )
  textSources.filter(textSource => textSource.checked).forEach(textSource => {
    textTarget.textContent = textSource.dataset.radioSelectionText
  })
  const controller = {
    element,
    onSelected
  }
  return controller
})
